/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 */

export type ApplicationStatus =
  (typeof ApplicationStatus)[keyof typeof ApplicationStatus];

export const ApplicationStatus = {
  active: 'active',
  inactive: 'inactive',
  deleted: 'deleted',
} as const;
